import {
    Component,
    ChangeDetectorRef,
    ViewChild,
    ElementRef,
    AfterViewInit
} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';

import {Constants} from '../../../shared/config/constants.config';
import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';
import {MasterService, MealWithDailyMealViewModel} from '../../../shared/services/master.service';
import {DailyMacroChangeComponent} from '../daily-macro-change/daily-macro-change.component';

@Component({
    selector: 'app-daily-macro-change-form-modal',
    templateUrl: './daily-macro-change-form.component.html',
    styleUrls: ['./daily-macro-change-form.component.scss']
})
export class DailyMacroChangeFormModalComponent implements AfterViewInit {
    private readonly mobileWidth: number = 576;

    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;
    dailyMacroChangeComponent: DailyMacroChangeComponent;

    day = '';
    dailyMeal = '';
    masterUserId: number;
    dailyMeals: MealWithDailyMealViewModel[] = [];

    selectedMealId = 0;
    overwritePercentage = 0;


    constructor(
        public readonly bsModalRef: BsModalRef,
        public readonly constants: Constants,
        private readonly masterService: MasterService,
        private readonly appIsLoadingEventsEmitter: AppLoadingEventsEmitter,
    ) {
    }

    // tslint:disable-next-line:use-life-cycle-interface
    ngOnInit() {
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);

        const interval = setInterval(() => {
            if (this.masterUserId) {
                clearInterval(interval);

                this.masterService.getMealsWithDailyMeals(this.masterUserId).subscribe(meals_with_daily_meal => {
                    this.dailyMeals = meals_with_daily_meal;

                    this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
                });

            }
        }, 100);
    }

    onClose() {
        this.bsModalRef.hide();
    }

    onCreate() {
        if (this.selectedMealId <= 0) {
            alert('Изберете хранене!');
            return;
        }

        const selectedMeal = this.dailyMeals.find(x => x.id === this.selectedMealId);

        this.dailyMacroChangeComponent.macrosComponent.daileMealPercentageOverwrites[this.dailyMacroChangeComponent.dailyOverwrite['id']]
            .push({
            macroId: this.dailyMacroChangeComponent.dailyOverwrite['id'],
            meal: selectedMeal,
            overwrite_percentage: this.overwritePercentage
        });
        //
        // this.dailyMacroChangeComponent.mealOverwrites.push({
        //     id: 0,
        //     macroId: this.dailyMacroChangeComponent.dailyOverwrite['id'],
        //     meal: selectedMeal,
        //     overwrite_percentage: this.overwritePercentage
        // });

        this.onClose();
    }

    ngAfterViewInit() {
        if (window.innerWidth <= this.mobileWidth) {
            this.toFullscreen();
        }
    }

    private toFullscreen() {
        const modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        const modalContent = this.wrapper.nativeElement.parentElement.parentElement;
        const modal = this.wrapper.nativeElement.parentElement;

        modalDialog.style.borderRadius = '0';
        modalDialog.style.display = 'flex';
        modalDialog.style.margin = '0';
        modalDialog.style.padding = '0';
        modalDialog.style.width = '100%';
        modalDialog.style.maxWidth = 'unset';
        modalDialog.style.minHeight = '100%';
        modalDialog.style.height = '100%';
        modalContent.style.borderRadius = '0';
        modal.style.display = 'block';
        modal.style.height = '100%';
    }

    onMealChange(event) {
        // tslint:disable-next-line:radix
        this.selectedMealId = parseInt(event.target.value);
    }

    onPercentageChange(event) {
        // tslint:disable-next-line:radix
        this.overwritePercentage = parseInt(event.target.value);
    }
}
